(function () {
  'use strict';

  var definitions = {
    surfaces: {
      lid: { key: 'lid', label: 'Lid' },
      front: { key: 'front', label: 'Front' },
      back: { key: 'back', label: 'Back' },
      left_side: { key: 'left_side', label: 'Left Side' },
      right_side: { key: 'right_side', label: 'Right Side' }
    },
    horizontal_alignments: {
      left: { key: 'left', label: 'Left' },
      center: { key: 'center', label: 'Center' },
      right: { key: 'right', label: 'Right' }
    },
    vertical_alignments: {
      top: { key: 'top', label: 'Top' },
      center: { key: 'center', label: 'Center' },
      bottom: { key: 'bottom', label: 'Bottom' }
    },
    orientations: {
      horizontal: { key: 'horizontal', label: 'Horizontal' },
      vertical: { key: 'vertical', label: 'Vertical' }
    },
    icon_relations_to_text: {
      independent: { key: 'independent', label: 'Custom position on lid' },
      left_of_text: { key: 'left_of_text', label: 'Left of text' },
      right_of_text: { key: 'right_of_text', label: 'Right of text' },
      above_text: { key: 'above_text', label: 'Above text' },
      below_text: { key: 'below_text', label: 'Below text' }
    },
    text_placements: {
      lid_center: { key: 'lid_center', label: 'Centered on lid', surface: 'lid', horizontal_align: 'center', vertical_align: 'center', orientation: 'horizontal', renderer_slot: 'text_lid_center_center_horizontal' },
      lid_top_center: { key: 'lid_top_center', label: 'Top center on lid', surface: 'lid', horizontal_align: 'center', vertical_align: 'top', orientation: 'horizontal', renderer_slot: 'text_lid_top_center_horizontal' },
      lid_bottom_center: { key: 'lid_bottom_center', label: 'Bottom center on lid', surface: 'lid', horizontal_align: 'center', vertical_align: 'bottom', orientation: 'horizontal', renderer_slot: 'text_lid_bottom_center_horizontal' },
      front_center: { key: 'front_center', label: 'Front center', surface: 'front', horizontal_align: 'center', vertical_align: 'center', orientation: 'horizontal', renderer_slot: 'text_front_center_center_horizontal' },
      back_center: { key: 'back_center', label: 'Back center', surface: 'back', horizontal_align: 'center', vertical_align: 'center', orientation: 'horizontal', renderer_slot: 'text_back_center_center_horizontal' },
      left_side_center_vertical: { key: 'left_side_center_vertical', label: 'Left side, vertical', surface: 'left_side', horizontal_align: 'center', vertical_align: 'center', orientation: 'vertical', renderer_slot: 'text_left_side_center_center_vertical' },
      right_side_center_vertical: { key: 'right_side_center_vertical', label: 'Right side, vertical', surface: 'right_side', horizontal_align: 'center', vertical_align: 'center', orientation: 'vertical', renderer_slot: 'text_right_side_center_center_vertical' }
    },
    icon_placements: {
      lid_left_of_text: { key: 'lid_left_of_text', label: 'Lid, left of text', surface: 'lid', horizontal_align: 'center', vertical_align: 'center', orientation: 'horizontal', relation_to_text: 'left_of_text', renderer_slot: 'icon_lid_left_of_text' },
      lid_right_of_text: { key: 'lid_right_of_text', label: 'Lid, right of text', surface: 'lid', horizontal_align: 'center', vertical_align: 'center', orientation: 'horizontal', relation_to_text: 'right_of_text', renderer_slot: 'icon_lid_right_of_text' },
      lid_center: { key: 'lid_center', label: 'Centered on lid', surface: 'lid', horizontal_align: 'center', vertical_align: 'center', orientation: 'horizontal', relation_to_text: 'independent', renderer_slot: 'icon_lid_center_center_horizontal' },
      front_center: { key: 'front_center', label: 'Front center', surface: 'front', horizontal_align: 'center', vertical_align: 'center', orientation: 'horizontal', relation_to_text: 'independent', renderer_slot: 'icon_front_center_center_horizontal' },
      back_center: { key: 'back_center', label: 'Back center', surface: 'back', horizontal_align: 'center', vertical_align: 'center', orientation: 'horizontal', relation_to_text: 'independent', renderer_slot: 'icon_back_center_center_horizontal' }
    },
    fonts: {
      standard: { key: 'standard', label: 'Standard', renderer_font_key: 'standard' },
      bold: { key: 'bold', label: 'Bold', renderer_font_key: 'bold' },
      fantasy: { key: 'fantasy', label: 'Fantasy', renderer_font_key: 'fantasy' },
      sci_fi: { key: 'sci_fi', label: 'Sci-Fi', renderer_font_key: 'sci_fi' }
    }
  };

  window.ArcaverseBuilderRuleDefinitions = definitions;

  function parseJsonElement(element, fallback) {
    if (!element) return fallback;

    try {
      var raw = String(element.textContent || '').trim();
      if (!raw) return fallback;
      var parsed = JSON.parse(raw);
      if (typeof parsed === 'string') {
        try { parsed = JSON.parse(parsed); } catch (innerError) {}
      }
      return parsed && typeof parsed === 'object' ? parsed : fallback;
    } catch (error) {
      return fallback;
    }
  }

  var root = document.querySelector('[id^="av-product-hero-"]');
  if (!root) return;

  var rules = parseJsonElement(root.querySelector('[id^="av-builder-rules-json-"]'), {});
  if (!rules || Number(rules.version) !== 2) return;

  window.ArcaverseBuilderRules = window.ArcaverseBuilderRules || {};
  window.ArcaverseBuilderRules[root.id] = rules;
})();
